import { dashboardService } from '@/services';

export const dashboardModule = {
  namespaced: true,
  state: () => ({
    orders:{
      data: {
        items: 0,
        units: 0,
      },
      error: null,
    },
    ordersBack:{
      data: {
        items: 0,
        units: 0,
      },
      error: null,
    },
    purchases:{
      data: {
        items: 0,
        units: 0,
      },
      error: null,
    },
    orderStocks:{
      data: {
        items: [],
        total: 0
      },
      error: null,
    },
    productStocks:{
      data: {
        items: [],
        total: 0
      },
      error: null,
    },
    warehousesStocks:{
      data: {
        items: [],
        start: null,
        end: null
      },
      error: null,
    },
    entitiesNotRegistered:{
      data: {
        orders: 0,
        orders_back: 0,
        purchases: 0
      },
      error: null,
    },
  }),
  mutations: {
    getEntitiesNotRegistered(state,) {
      dashboardService.getEntitiesNotRegistered()
      .then((res) => {
        state.entitiesNotRegistered.data = { ...res }
        state.entitiesNotRegistered.error = null
      })
      .catch((error) => {
        state.entitiesNotRegistered.data = null
        state.entitiesNotRegistered.error = error
      });    
    },
    getOrders(state,) {
      dashboardService.getOrders()
      .then((res) => {
        state.orders.data = { ...res }
        state.orders.error = null
      })
      .catch((error) => {
        state.orders.data = null
        state.orders.error = error
      });    
    },
    getOrdersBack(state,) {
      dashboardService.getOrdersBack()
        .then((res) => {
          state.ordersBack.data = { ...res }
          state.ordersBack.error = null
        })
        .catch((error) => {
          state.ordersBack.data = null
          state.ordersBack.error = error
        });      
    },
    getPurchases(state,) {
      dashboardService.getPurchases()
        .then((res) => {
          state.purchases.data = { ...res }
          state.purchases.error = null
        })
        .catch((error) => {
          state.purchases.data = null
          state.purchases.error = error
        });      
    },
    getOrderStock(state, request) {
      dashboardService.getOrderStock(request.pagination, request.filters)
        .then((res) => {
          state.orderStocks.data = { ...res }
          state.orderStocks.error = null
        })
        .catch((error) => {
          state.orderStocks.data = null
          state.orderStocks.error = error
        });      
    },
    getProductStock(state, request) {
      dashboardService.getProductStock(request.pagination, request.filters)
        .then((res) => {
          state.productStocks.data = { ...res }
          state.productStocks.error = null
        })
        .catch((error) => {
          state.productStocks.data = null
          state.productStocks.error = error
        });      
    },
    getWarehousesStock(state) {
      dashboardService.getWarehousesStock()
        .then((res) => {
          state.warehousesStocks.data = { ...res }
          state.warehousesStocks.error = null
        })
        .catch((error) => {
          state.warehousesStocks.data = null
          state.warehousesStocks.error = error
        });      
    },
  }
}